module.exports = __webpack_public_path__ + "static/img/dashboard.82cec21.svg";